import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CloseIcon from '@mui/icons-material/Close';
import PhonePausedIcon from '@mui/icons-material/PhonePaused';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PauseIcon from '@mui/icons-material/Pause';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import RestoreIcon from '@mui/icons-material/Restore';
import {
  Card,
  Grid,
  Box,
  IconButton,
  Tooltip,
  Dialog,
  DialogContent,
  DialogActions,
  ListItemButton,
  ListItemIcon,
  Divider,
  CircularProgress,
  Skeleton,
  Badge
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import { styled, useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  trTR
} from '@mui/x-data-grid';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InvoiceDetail from 'src/components/InvoiceDetail';
import {
  getSubStatuses,
  getSolutionCenterSubStatus
} from 'src/store/slices/assigmentSlice';
import {
  getChangeReasonItems,
  getCityItems,
  getConfirmTypeItems,
  getCustomerTypes,
  getProductItems,
  getRegionItems,
  getStatusItems,
  getSubStatusItems,
  getAronStatusItems,
  getRefundMoneyItems
} from 'src/store/slices/commonSlice';
import {
  generalFollowActions,
  getCMSearch,
  getCMSummary,
  getDetail,
  getFileType,
  getPool,
  waitingPoolReceipt,
  insertFisListControl,
  getRefundInformationForm,
  waitingPoolReceiptUpdate
} from 'src/store/slices/generalFollowSlice';
import {
  getReceiptInfoChat,
  informationChatActions
} from 'src/store/slices/informationChatSlice';
import AlertAndLoading from 'src/components/AlertAndLoading';
import CopyButton from 'src/components/CopyButton';
import { getUser, getUserRole } from 'src/utils/Common';
import { getFisListControl } from 'src/store/slices/generalFollowSlice';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ReceiptLongSharpIcon from '@mui/icons-material/ReceiptLongSharp';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HistorySharpIcon from '@mui/icons-material/HistorySharp';
import Print from 'src/components/Print';
import axios from 'src/utils/axios';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import Chip from '@mui/material/Chip';
import { keyframes } from '@mui/system';

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 152, 0, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 152, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 152, 0, 0);
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%'
  },
  AccordionStyle: {
    border: 'none',
    borderRadius: '12px !important',
    zIndex: 1000,
    bottom: '1rem',
    right: '2rem',
    position: 'fixed',
    width: '300px',
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.15)',
    background: 'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-3px)',
      boxShadow: '0 8px 28px rgba(0, 0, 0, 0.2)'
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      background: 'linear-gradient(90deg, #FFD700, #FFA500, #FF8C00)',
      animation: `${pulseAnimation} 2s ease-in-out infinite`
    }
  },
  FisNoBox: {
    color: '#b02121b0',
    fontWeight: '400'
  }
}));

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  '& .ant-empty-img-1': {
    fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626'
  },
  '& .ant-empty-img-2': {
    fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959'
  },
  '& .ant-empty-img-3': {
    fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343'
  },
  '& .ant-empty-img-4': {
    fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c'
  },
  '& .ant-empty-img-5': {
    fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
    fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff'
  }
}));
function CustomNoRowsOverlay() {
  return (
    <StyledGridOverlay>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <Box sx={{ mt: 1 }}>Satır Bulunamadı</Box>
    </StyledGridOverlay>
  );
}

function GeneralFollow() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const SessionUser = getUser();
  const theme = useTheme();
  const userRole = getUserRole().UserBasedComponent;

  const regionData = useSelector((state) => state.commonSlice.regionItems);
  const cityData = useSelector((state) => state.commonSlice.cityItems);
  const confirmTypeData = useSelector(
    (state) => state.commonSlice.confirmTypeItems
  );
  const changeReasonData = useSelector(
    (state) => state.commonSlice.changeReasonItems
  );
  const statusData = useSelector((state) => state.commonSlice.statuses);
  const aronStatusData = useSelector((state) => state.commonSlice.aronStatuses);
  const refundMoney = useSelector((state) => state.commonSlice.refundMoney);
  const subStatusData = useSelector((state) => state.commonSlice.subStatuses);
  const productsData = useSelector((state) => state.commonSlice.products);
  const customerTypeData = useSelector(
    (state) => state.commonSlice.customerTypes
  );
  const activeTab = useSelector((state) => state.generalFollowSlice.activedTab);
  const UpdatedRowCount = useSelector(
    (state) => state.generalFollowSlice.updatedRowCount
  );
  const UpdatedProductInformation = useSelector(
    (state) => state.generalFollowSlice.updatedProductInformation
  );
  const dataSort = useSelector(
    (state) => state.generalFollowSlice.updatedDataGridSort
  );
  const commonSliceLastUpdate = useSelector(
    (state) => state.commonSlice.lastUpdateDate
  );

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const exDatas = useSelector((state) => state.generalFollowSlice.exDatas);

  const [expanded, setExpanded] = React.useState(false);
  const [expandedSearch, setExpandedSearch] = React.useState(false);
  const [customerTypes, setCustomerTypes] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const [customerName, setCustomerName] = React.useState('');
  const [customerSurname, setCustomerSurname] = React.useState('');
  const [retailer, setRetailer] = React.useState('');
  const [modelCode, setModelCode] = React.useState('');
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [receiptNumber, setReceiptNumber] = React.useState('');
  const [invoiceNumber, setInvoiceNumber] = React.useState('');

  const [selectedRegion, setSelectedRegion] = React.useState(
    regionData.filter((i) => i.Id == 0)
  );
  const [selectedCity, setSelectedCity] = React.useState(
    cityData.filter((i) => i.Id == 0)
  );
  const [selectedConfirmType, setConfirmType] = React.useState(
    confirmTypeData.filter((i) => i.Id == 0)
  );
  const [selectedChangeReason, setChangeReason] = React.useState(
    changeReasonData.filter((i) => i.Id == 0)
  );
  const [selectedStatus, setStatus] = React.useState(
    statusData.filter((i) => i.Id == 0)
  );
  const [selectedAronStatus, setAronStatus] = React.useState(
    aronStatusData.filter((i) => i.Id == 0)
  );
  const [selectedRefundMoney, setRefundMoney] = React.useState(
    refundMoney.filter((i) => i.Id == 0)
  );
  const [selectedSubStatus, setSubStatus] = React.useState(
    subStatusData.filter((i) => i.Id == 0)
  );
  const [selectedProduct, setProduct] = React.useState(
    productsData.filter((i) => i.Id == 0)
  );
  const [selectedCustomerType, setSelectedCustomerType] = React.useState([]);
  const [productInformation, setProductInformation] = React.useState([]);
  const [columnHide, setColumnHide] = React.useState(false);
  const [waitingReasonPopUp, setWaitingReasonsPopUp] = React.useState(false);
  const [waitingReasonUpdatePopUp, setWaitingReasonUpdatePopUp] =
    React.useState(false);
  const [waitingReceiptNo, setWaitingReceiptNo] = React.useState(null);
  const [waitingServiceNumber, setWaitingServiceNumber] = React.useState(null);
  const [waitingApplicationNumber, setWaitingApplicationNumber] =
    React.useState(null);
  const [waitingDsc, setWaitingDsc] = React.useState('');
  const [waitingStatus, setWaitingStatus] = React.useState(null);
  const [printOpen, setPrintOpen] = React.useState(false);
  const [printData, setPrintData] = React.useState([]);

  const [startDate, setStartDate] = React.useState(
    moment().subtract(2, 'month')
  );
  const [endDate, setEndDate] = React.useState(moment());

  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({
    ErrorType: 'error',
    ErrorTitle: 'Uyarı'
  });
  const [responseMessage, setresponseMessage] = React.useState('');

  const [fisListControl, setFisListControl] = React.useState([]);
  const [fisExpanded, setFisExpanded] = React.useState(false);
  const [fisListLoading, setFisListLoading] = React.useState(false);
  const [automationDetailOpen, setAutomationDetailOpen] = React.useState(false);
  const [automationConfirmOpen, setAutomationConfirmOpen] =
    React.useState(false);
  const [selectedAutomationRow, setSelectedAutomationRow] =
    React.useState(null);
  const [currentReceiptInfo, setCurrentReceiptInfo] = React.useState(null);
  const [closedAlerts, setClosedAlerts] = React.useState([]);

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    });
    setUyari(true);

    // Success ve Error mesajları için otomatik kapanma (3 saniye)
    if (ErrorType === 'success' || ErrorType === 'error') {
      setTimeout(() => {
        setUyari(false);
      }, 3000);
    }

    return;
  }

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const handleChangeStartDate = (e) => {
    setStartDate(e);
  };

  const handleChangeEndDate = (e) => {
    setEndDate(e);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    // Kapatılan uyarıyı kaydet (kapanmadan önce kaydet)
    if (uyari && responseMessage && alertType) {
      const alertToSave = {
        message: responseMessage,
        type: alertType.ErrorType,
        title: alertType.ErrorTitle,
        timestamp: new Date()
      };

      setClosedAlerts((prev) => [...prev, alertToSave]);
    }

    setUyari(false);
  };

  const showClosedAlert = () => {
    if (closedAlerts.length > 0) {
      // İlk kapatılan uyarıyı tekrar göster
      const alert = closedAlerts[0];
      setresponseMessage(alert.message);
      setAlertType({
        ErrorType: alert.type,
        ErrorTitle: alert.title
      });
      setUyari(true);
      // Listeden çıkar
      setClosedAlerts((prev) => prev.slice(1));
    }
  };

  const handlePrintModal = (e, cellValues) => {
    e.stopPropagation();

    const data = [
      cellValues.row.BASVURU_NO.toString(),
      cellValues.row.BIRIM_KODU.toString(),
      cellValues.row.MUSTERI_TIPI.toString()
    ];

    setLoading(true);
    dispatch(getRefundInformationForm(data))
      .then((response) => {
        if (response.payload.length > 0) {
          setPrintData(response.payload);
          setPrintOpen(true);
        } else {
          InfoAlert('Kayıt bulunamadı!...', 'error', 'Uyarı');
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        return;
      });
  };

  const SelectableListItemText = styled(ListItemText)({
    userSelect: 'text'
  });

  const columns = [
    {
      field: 'Yazdır',
      headerName: '',
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{ justifyContent: 'center', '& > :not(style)': { m: 1 } }}
            onClick={(e) => handlePrintModal(e, cellValues)}
          >
            <IconButton>
              <LocalPrintshopIcon />
            </IconButton>
          </Box>
        );
      },
      width: 70
    },
    {
      field: 'Beklemeye Al',
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{ justifyContent: 'center', '& > :not(style)': { m: 1 } }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {cellValues?.row?.BEKLEMEDE == true ? (
              <Tooltip title="Bekleme Nedenini Güncelle">
                <IconButton
                  onClick={() => {
                    setWaitingReasonUpdatePopUp(true);
                    setWaitingStatus(cellValues?.row?.DEGISIMDURUM);
                    setWaitingApplicationNumber(cellValues?.row?.BASVURU_NO);
                    setWaitingServiceNumber(cellValues?.row?.BIRIM_KODU);
                  }}
                >
                  <PauseIcon sx={{ color: 'red' }} disabled />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Beklemeye Al">
                <IconButton
                  onClick={() => {
                    setWaitingStatus(cellValues?.row?.DEGISIMDURUM);
                    setWaitingReasonsPopUp(true);
                    setWaitingReceiptNo(cellValues?.row?.FIS_NO);
                    setWaitingApplicationNumber(cellValues?.row?.BASVURU_NO);
                    setWaitingServiceNumber(cellValues?.row?.BIRIM_KODU);
                  }}
                >
                  <PlayArrowIcon sx={{ color: 'green' }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
      width: 100,
      hide: columnHide
    },
    { field: 'SIRA', headerName: '', width: 50 },
    { field: 'SERVIS', headerName: 'Servis', width: 200 },
    {
      field: 'FIS_NO',
      headerName: 'Fiş Numarası',
      width: 130,
      renderCell: (cellValues) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <span>{cellValues.value}</span>
          {cellValues.value && <CopyButton value={cellValues.value} title="Fiş numarasını kopyala" />}
        </Box>
      )
    },
    { field: 'DEGISIM_FATURA_NO', headerName: 'Fatura No', width: 150 },
    { field: 'UST_BIRIM_ACIKLAMA', headerName: 'Bölge', width: 200 },
    { field: 'ADSOYAD', headerName: 'Ad Soyad', width: 250 },
    { field: 'DURUM', headerName: 'Durum', width: 250 },
    { field: 'ARON_DURUM_ACIKLAMA', headerName: 'Fiş Durum', width: 250 },
    {
      field: 'PARAIADESI',
      headerName: 'Para İadesi / Değişim Çeki Açıklama',
      width: 250
    },
    { field: 'URUN_ACIKLAMA', headerName: 'Ürün Tanımı', width: 300 },
    {
      field: 'MUSTERI_TIP_ACIKLAMA',
      headerName: 'Müşteri Tipi',
      width: 100,
      hide: true
    },
    {
      field: 'ISLEM_TARIHI',
      headerName: 'İşlem Tarihi',
      width: 150,
      renderCell: (cellValues) => {
        return moment(cellValues.row.ISLEM_TARIHI).format(
          'DD/MM/YYYY HH:mm:ss'
        );
      }
    },
    {
      field: 'CAGRI_TARIHI',
      headerName: 'Çağrı Tarihi',
      width: 150,
      renderCell: (cellValues) => {
        return moment(cellValues.row.CAGRI_TARIHI).format(
          'DD/MM/YYYY HH:mm:ss'
        );
      }
    },
    { field: 'BASVURU_NO', headerName: 'Başvuru No', width: 100, hide: true },
    { field: 'STOK_NO', headerName: 'Stok No', width: 100 },
    { field: 'POOL_DESC', headerName: 'Havuz Adı', width: 250 },
    { field: 'SICILNO', headerName: 'Atanan Kişi', width: 150 },
    { field: 'SERINO', headerName: 'Yıl/Ay/SeriNo', width: 150 },
    { field: 'TEL1', headerName: 'Telefon', width: 100, hide: true },
    { field: 'STOK_NO', headerName: 'Stok No', width: 100 },
    {
      field: 'SERVIS_TESLIM_TARIHI',
      headerName: 'Servise Teslim Tarihi',
      width: 150,
      hide: true
    },
    {
      field: 'DEGISIM_FATURA_KALEM_ADET',
      headerName: 'Adet',
      width: 150,
      hide: true
    }
  ];

  useEffect(() => {
    if (
      !commonSliceLastUpdate ||
      moment(commonSliceLastUpdate).add(12, 'hours') <= moment()
    ) {
      dispatch(getRegionItems());
      dispatch(getConfirmTypeItems());
      dispatch(getChangeReasonItems());
      dispatch(getStatusItems());
      dispatch(getSubStatusItems());
      dispatch(getProductItems());
      dispatch(getCustomerTypes());
      dispatch(getFileType());
      dispatch(getSubStatuses());
      dispatch(getAronStatusItems());
      dispatch(getRefundMoneyItems());
    }
    dispatch(getSolutionCenterSubStatus());
    Pools();
    dispatch(generalFollowActions.updateActiveTab('1'));
    dispatch(
      generalFollowActions.updateDataGridSort({ field: 'SIRA', sort: 'asc' })
    );
    dispatch(generalFollowActions.updateRowCount(0));
  }, [dispatch]);

  useEffect(() => {
    setCustomerTypes(customerTypeData);
    setSelectedCustomerType(customerTypeData);
  }, [customerTypeData]);

  function QuickSearchToolbar(props) {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={4} md={4}>
            <GridToolbarContainer>
              <GridToolbarColumnsButton sx={{ color: '#FF9800' }} />
              <GridToolbarExport
                sx={{ color: '#FF9800' }}
                csvOptions={{
                  utf8WithBom: true
                }}
              />
            </GridToolbarContainer>
          </Grid>
          <Grid item xs={4} md={4}>
            <Typography
              variant="body2"
              color="textSecondary"
              component="div"
              sx={{
                width: '100%',
                textAlign: 'center',
                fontWeight: 'bold',
                color: '#424242'
              }}
            >
              {'Toplam '}
              {UpdatedRowCount}
              {' Adet Fiş bulunmaktadır.'}
            </Typography>
          </Grid>
          <Grid item xs={2} md={2}></Grid>
          <Grid item xs={2} md={2}>
            <Button
              fullWidth
              size="small"
              sx={{
                color: '#FF9800',
                backgroundColor: '#424242',
                borderRadius: '10px',
                fontSize: '0.75rem',
                fontWeight: 600,
                padding: '6px 16px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: '#FF9800',
                  color: '#fff',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)'
                }
              }}
              onClick={() => Pools()}
            >
              Atanan İşlerim
            </Button>
          </Grid>
        </Grid>
      </Box>
    );
  }

  function Pools() {
    dispatch(generalFollowActions.updateProductInformation([]));
    const data = {
      SESSION_USER_ID: SessionUser?.UserId?.toString() || null
    };
    setLoading(true);
    dispatch(getPool(data))
      .then((response) => {
        if (response.payload?.length > 0) {
          setProductInformation(
            response.payload?.map((W) => ({
              SERVIS: W.KUL_BIRIM_KODU + '-' + W.SERVIS,
              FIS_NO: W.FIS_NO,
              ADSOYAD: W.ADSOYAD,
              STOK_NO: W.STOK_NO,
              CAGRI_TARIHI: W.CAGRI_TARIHI
                ? moment(W.CAGRI_TARIHI).format('DD.MM.YYYY')
                : '',
              ISLEM_TARIHI: W.ISLEM_TARIHI
                ? moment(W.ISLEM_TARIHI).format('DD.MM.YYYY')
                : '',
              URUN_ACIKLAMA: W.URUN_ACIKLAMA,
              DURUM: W.DURUM,
              POOL_DESC: W.POOL_DESC,
              SICILNO: W.SICILNO,
              MUSTERI_TIP_ACIKLAMA: W.MUSTERI_TIP_ACIKLAMA,
              TEL1: W.TEL1,
              BIRIM_KODU: W.BIRIM_KODU,
              UST_BIRIM_ACIKLAMA: W.UST_BIRIM_KODU + '-' + W.UST_BIRIM_ACIKLAMA,
              SERVIS_TESLIM_TARIHI: W.SERVIS_TESLIM_TARIHI,
              SERINO: W.UYIL + '/' + W.UDONEM + '/' + W.SERINO,
              BASVURU_NO: W.BASVURU_NO,
              DEGISIM_FATURA_KALEM_ADET: W.DEGISIM_FATURA_KALEM_ADET,
              NITELIK_KODU: W.NITELIK_KODU,
              DEGISIM_FATURA_NO: W.DEGISIM_FATURA_NO
                ? W.DEGISIM_FATURA_NO
                : '-',
              SIRA: W.SIRA,
              BEKLEMEDE: W.BEKLEMEDE ? W.BEKLEMEDE : 0
            }))
          );
          setColumnHide(false);
          setLoading(false);
          dispatch(
            generalFollowActions.updateRowCount(response.payload.length)
          );
          dispatch(
            generalFollowActions.updateProductInformation(response.payload)
          );
        } else {
          setLoading(false);
          setProductInformation([]);
          dispatch(generalFollowActions.updateRowCount(0));
          dispatch(generalFollowActions.updateProductInformation([]));
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }

  async function searchProductSummary() {
    setColumnHide(true);
    setProductInformation([]);
    dispatch(generalFollowActions.updateProductInformation([]));

    var regionsList = [];
    selectedRegion.map((i) => {
      regionsList.push(i.Id);
    });

    var cityList = [];
    selectedCity.map((i) => {
      cityList.push(i.Id);
    });

    var changeReasonList = [];
    selectedChangeReason.map((i) => {
      changeReasonList.push(i.Id);
    });

    var statusList = [];
    selectedStatus.map((i) => {
      statusList.push(i.Id);
    });

    var aronStatusList = [];
    selectedAronStatus.map((i) => {
      aronStatusList.push(i.Id);
    });

    var refundMoneyList = [];
    selectedRefundMoney.map((i) => {
      refundMoneyList.push(i.Id);
    });

    var subStatusList = [];
    selectedSubStatus.map((i) => {
      subStatusList.push(i.Id);
    });

    var customerTypesList = [];
    selectedCustomerType.map((i) => {
      customerTypesList.push(i.Id);
    });

    var productTypesList = [];
    selectedProduct.map((i) => {
      productTypesList.push(i.Id);
    });

    var confirmTypesList = [];
    selectedConfirmType.map((i) => {
      confirmTypesList.push(i.Id);
    });

    const data = {
      BIRIM_KODU: cityList.toString() || '0',
      BOLGE_BIRIM_KODU: regionsList.toString() || '0',
      ONAY_TIPI: confirmTypesList.toString() || '0',
      DURUM: statusList.toString() || '0',
      ARON_DURUM: aronStatusList.toString() || '0',
      PARA_IADE: refundMoneyList.toString() || '0',
      BASLANGIC_TARIHI: moment(startDate).format('DD-MM-YYYY'),
      BITIS_TARIHI: moment(endDate).format('DD-MM-YYYY'),
      URUN_GRUP: productTypesList.toString() || '0',
      MUSTERI_TIP: customerTypesList.toString() || '0',
      DEGISIM_NEDENI: changeReasonList.toString() || '0',
      ALT_DURUM: subStatusList.toString() || '0',
      SESSION_USER_ID: SessionUser?.UserId?.toString() || 0
    };
    setLoading(true);
    dispatch(getCMSummary(data))
      .then((response) => {
        if (response.payload?.length > 0) {
          setProductInformation(
            response.payload?.map((W) => ({
              SERVIS: W.KUL_BIRIM_KODU + '-' + W.SERVIS,
              FIS_NO: W.FIS_NO,
              ADSOYAD: W.ADSOYAD,
              STOK_NO: W.STOK_NO,
              CAGRI_TARIHI: W.CAGRI_TARIHI
                ? moment(W.CAGRI_TARIHI).format('DD.MM.YYYY')
                : '',
              ISLEM_TARIHI: W.ISLEM_TARIHI
                ? moment(W.ISLEM_TARIHI).format('DD.MM.YYYY')
                : '',
              URUN_ACIKLAMA: W.URUN_ACIKLAMA,
              DURUM: W.DURUM,
              ARON_DURUM_ACIKLAMA: W.ARON_DURUM,
              PARAIADESI: W.PARAIADESI,
              POOL_DESC: W.POOL_DESC,
              SICILNO: W.SICILNO,
              MUSTERI_TIP_ACIKLAMA: W.MUSTERI_TIP_ACIKLAMA,
              TEL1: W.TEL1,
              BIRIM_KODU: W.BIRIM_KODU,
              UST_BIRIM_ACIKLAMA: W.UST_BIRIM_KODU + '-' + W.UST_BIRIM_ACIKLAMA,
              SERVIS_TESLIM_TARIHI: W.SERVIS_TESLIM_TARIHI,
              SERINO: W.UYIL + '/' + W.UDONEM + '/' + W.SERINO,
              BASVURU_NO: W.BASVURU_NO,
              DEGISIM_FATURA_KALEM_ADET: W.DEGISIM_FATURA_KALEM_ADET,
              NITELIK_KODU: W.NITELIK_KODU,
              DEGISIM_FATURA_NO: W.DEGISIM_FATURA_NO
                ? W.DEGISIM_FATURA_NO
                : '-',
              SIRA: W.SIRA,
              BEKLEMEDE: W.BEKLEMEDE
            }))
          );
          dispatch(
            generalFollowActions.updateRowCount(response.payload.length)
          );
          dispatch(
            generalFollowActions.updateProductInformation(response.payload)
          );
          setLoading(false);
        } else {
          setLoading(false);
          setProductInformation([]);
          dispatch(generalFollowActions.updateProductInformation([]));
          dispatch(generalFollowActions.updateRowCount(0));
          return;
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        return;
      });
  }

  function CMDetail(rowData) {
    dispatch(generalFollowActions.resetDetails());
    dispatch(informationChatActions.resetChat()); //Mesaj alanına gelen dataları resetler

    // Fiş bilgilerini sakla
    setCurrentReceiptInfo({
      BIRIM_KODU: rowData.BIRIM_KODU,
      BASVURU_NO: rowData.BASVURU_NO
    });

    dispatch(getReceiptInfoChat([rowData.BASVURU_NO, rowData.BIRIM_KODU]));

    const data = {
      SessionUser: SessionUser?.UserId || 0,
      UnitCode: rowData.BIRIM_KODU,
      ApplicationNumber: rowData.BASVURU_NO
    };
    setLoading(true);
    dispatch(getDetail(data))
      .then((response) => {
        if (response?.payload?.length > 0) {
          setLoading(false);

          // Otomasyon fiş bilgisini kontrol et
          const isAutomation =
            response?.payload[0]?.OTOMASYON_FISI_MI === 1 ||
            response?.payload[0]?.OTOMASYON_FISI_MI === true;

          // Eğer otomasyonlu fiş ise popup aç
          if (isAutomation) {
            setAutomationDetailOpen(true);
          }

          dispatch(generalFollowActions.updateActiveTab('2')); //Tab panel 2'yi açar.
          dispatch(
            generalFollowActions.updateOfferPrice(
              response?.payload[0]?.Exchange?.Price
            )
          );
          dispatch(
            generalFollowActions.updateRecomendedPrice(
              response?.payload[0]?.Exchange?.RecomendedPrice
            )
          );
          dispatch(
            generalFollowActions.updateTopModelDifferentPrice(
              response?.payload[0]?.Exchange?.ProductRemainPrice
            )
          );
          //Fiş yüklenirken alt model fark tutarı da store'a yazılır. Aksi halde kullanıcı
          //bu alana dokunmadıkça hesaplamalar bir önceki fişin değeri ile yapılır.
          dispatch(
            generalFollowActions.updateSubModelDifferenceAmount(
              response?.payload[0]?.Exchange?.SubModelDifferenceAmount ?? 0
            )
          );
          dispatch(generalFollowActions.exData(response?.payload));
        } else {
          setLoading(false);
          dispatch(generalFollowActions.updateActiveTab('2'));
          dispatch(generalFollowActions.resetDetails());
          dispatch(informationChatActions.resetChat());
          return <></>;
        }
      })
      .catch((error) => {
        setLoading(false);
        return;
      });
  }

  const handleChangeTabs = (event, newValue) => {
    dispatch(generalFollowActions.updateActiveTab(newValue));
  };

  function searchSummary() {
    setColumnHide(true);
    setProductInformation([]);
    dispatch(generalFollowActions.updateProductInformation([]));

    const data = {
      CustomerName: customerName?.trim().toString() || null,
      CustomerSurname: customerSurname?.trim().toString() || null,
      ReceiptNumber: receiptNumber?.trim().toString() || null,
      CustomerPhone: phoneNumber?.trim().toString() || null,
      Retailer: retailer?.trim().toString() || null,
      InvoiceNumber: invoiceNumber?.trim().toString() || null,
      ModelCode: modelCode?.trim().toString() || null,
      SessionUser: SessionUser?.UserId?.toString() || null
    };
    setLoading(true);
    dispatch(getCMSearch(data))
      .then((response) => {
        if (response.payload?.length > 0) {
          setProductInformation(
            response.payload?.map((W) => ({
              ADSOYAD: W.ADSOYAD,
              BASVURU_NO: W.BASVURU_NO,
              BIRIM_KODU: W.BIRIM_KODU,
              CAGRI_TARIHI: W.CAGRI_TARIHI
                ? moment(W.CAGRI_TARIHI).format('DD.MM.YYYY')
                : '',
              FIS_NO: W.FIS_NO,
              ISLEM_TARIHI: W.ISLEM_TARIHI
                ? moment(W.ISLEM_TARIHI).format('DD.MM.YYYY')
                : '',
              SERINO: W.UYIL + '/' + W.UDONEM + '/' + W.SERINO,
              SERVIS: W.KUL_BIRIM_KODU + '-' + W.SERVIS,
              URUN_ACIKLAMA: W.URUN_ACIKLAMA,
              DURUM: W.DURUM,
              TEL1: W.TEL1,
              UST_BIRIM_ACIKLAMA: W.UST_BIRIM_KODU + '-' + W.UST_BIRIM_ACIKLAMA,
              BASVURU_NO: W.BASVURU_NO,
              NITELIK_KODU: W.NITELIK_KODU,
              SIRA: W.SIRA,
              BEKLEMEDE: 0
            }))
          );
          dispatch(
            generalFollowActions.updateRowCount(response.payload.length)
          );
          dispatch(
            generalFollowActions.updateProductInformation(response.payload)
          );
          setLoading(false);
          setCustomerName('');
          setCustomerSurname('');
          setReceiptNumber('');
          setPhoneNumber('');
          setRetailer('');
          setModelCode('');
          setInvoiceNumber('');
        } else {
          setLoading(false);
          dispatch(generalFollowActions.updateRowCount(0));
          setProductInformation([]);
          dispatch(generalFollowActions.updateProductInformation([]));
          InfoAlert('Aradığınız kriterde sonuç bulunamadı.', 'error', 'Hata');
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        return;
      });
  }

  function GetCity(value) {
    setSelectedRegion(value);
    var RegionList = [];
    value.map((i) => {
      RegionList.push(i.Id);
    });
    setLoading(true);
    dispatch(getCityItems({ ItemId: '2', ItemValue: RegionList.toString() }))
      .then((response) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        return;
      });
  }

  function DataGridSorting(model) {
    if (model.length == 0) {
      dispatch(generalFollowActions.updateDataGridSort(dataSort));
      return;
    }
    dispatch(generalFollowActions.updateDataGridSort(model[0]));
  }
  function RefreshDetail() {
    if (!currentReceiptInfo) {
      InfoAlert('Yenilenecek fiş bilgisi bulunamadı.', 'warning', 'Uyarı');
      return;
    }

    const data = {
      SessionUser: SessionUser?.UserId || 0,
      UnitCode: currentReceiptInfo.BIRIM_KODU,
      ApplicationNumber: currentReceiptInfo.BASVURU_NO
    };

    setLoading(true);
    dispatch(getDetail(data))
      .then((response) => {
        if (response?.payload?.length > 0) {
          setLoading(false);

          dispatch(
            generalFollowActions.updateOfferPrice(
              response?.payload[0]?.Exchange?.Price
            )
          );
          dispatch(
            generalFollowActions.updateRecomendedPrice(
              response?.payload[0]?.Exchange?.RecomendedPrice
            )
          );
          dispatch(
            generalFollowActions.updateTopModelDifferentPrice(
              response?.payload[0]?.Exchange?.ProductRemainPrice
            )
          );
          //Fiş yüklenirken alt model fark tutarı da store'a yazılır. Aksi halde kullanıcı
          //bu alana dokunmadıkça hesaplamalar bir önceki fişin değeri ile yapılır.
          dispatch(
            generalFollowActions.updateSubModelDifferenceAmount(
              response?.payload[0]?.Exchange?.SubModelDifferenceAmount ?? 0
            )
          );
          dispatch(generalFollowActions.exData(response?.payload));
          InfoAlert(
            'Fiş bilgileri başarıyla yenilendi.',
            'success',
            'Başarılı'
          );
        } else {
          setLoading(false);
          InfoAlert('Fiş bilgileri yüklenemedi.', 'error', 'Hata');
        }
      })
      .catch((error) => {
        setLoading(false);
        InfoAlert('Fiş bilgileri yüklenirken hata oluştu.', 'error', 'Hata');
      });
  }

  function waitingPool() {
    if (!waitingDsc) {
      InfoAlert(
        'Lütfen beklemeye alma nedeninizi yazınız!...',
        'error',
        'Uyarı'
      );
    }
    Log();

    setLoading(true);
    const data = {
      Dsc: waitingDsc.toString(),
      ServiceNumber: waitingServiceNumber, //Servis Numarası
      ApplicationNumber: waitingApplicationNumber?.toString() //Başvuru No
      //SessionUser: SessionUser?.UserId?.toString()
    };
    dispatch(waitingPoolReceipt(data))
      .then((response) => {
        setWaitingDsc('');
        setWaitingReasonsPopUp(false);
        setLoading(false);
        if (response.payload.ErrorCode == '0') {
          InfoAlert(response.payload.ErrorDescription, 'success', 'Başarılı');
          Pools();
        } else {
          InfoAlert(response.payload.ErrorDescription, 'error', 'Hata');
        }
      })
      .catch((err) => {
        setWaitingDsc('');
        setWaitingReasonsPopUp(false);
        setLoading(false);
        return;
      });
  }

  function updateWaitingPoolReceipt() {
    if (!waitingDsc) {
      InfoAlert(
        'Lütfen beklemeye alma nedeninizi yazınız!...',
        'error',
        'Uyarı'
      );
      return;
    }
    Log();
    setLoading(true);
    const data = {
      Dsc: waitingDsc.toString(),
      ServiceNumber: waitingServiceNumber, //Servis Numarası
      ApplicationNumber: waitingApplicationNumber?.toString() //Başvuru No
      //SessionUser: SessionUser?.UserId?.toString()
    };
    dispatch(waitingPoolReceiptUpdate(data))
      .then((response) => {
        setWaitingDsc('');
        setWaitingReasonUpdatePopUp(false);
        setLoading(false);
        if (response.payload.ErrorCode == '0') {
          InfoAlert(response.payload.ErrorDescription, 'success', 'Başarılı');
          Pools();
        } else {
          InfoAlert(response.payload.ErrorDescription, 'error', 'Hata');
        }
      })
      .catch((err) => {
        setWaitingDsc('');
        setWaitingReasonUpdatePopUp(false);
        setLoading(false);
        return;
      });
  }

  function InsertFisListControl(rowData) {
    const data = {
      SicilNo: SessionUser?.UserId?.toString(),
      FisNo: rowData.FIS_NO
    };

    dispatch(insertFisListControl(data));
  }

  function GetFisListControl() {
    setFisListLoading(true);
    dispatch(getFisListControl(SessionUser?.UserId?.toString()))
      .then((response) => {
        if (response.payload?.length > 0) {
          setFisListControl(response.payload);
        } else {
          setFisListControl([]);
        }
        setFisListLoading(false);
      })
      .catch(() => {
        setFisListLoading(false);
      });
  }

  function Log() {
    var Message = '';
    const LogData = {
      ServiceNumber: waitingServiceNumber.toString(), //Servis Numarası
      ApplicationNumber: waitingApplicationNumber.toString(), //Başvuru No
      UserID: invoiceData[0]?.UserID,
      Status: waitingStatus,
      Note: waitingDsc?.toString()
    };

    if (waitingDsc != '') {
      Message = 'Bekleme Nedeni:' + ' ' + waitingDsc?.toString();
    }

    LogData.Note = Message;

    axios
      .post('WaitingReasonLog', LogData, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        setLoading(false);
        return;
      })
      .catch((err) => {
        setLoading(false);
        return;
      });
  }

  return (
    <>
      <AlertAndLoading
        Message={responseMessage}
        open={uyari}
        AlertType={alertType}
        onClose={uyariKapat}
        loading={loading}
      />
      <Card sx={{ borderRadius: '16px', border: '1px solid #e0e0e0', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <TabContext value={activeTab}>
          {/* Sekme çubuğu: iki sekme yarı yarıya; detaydayken Açık İşler sekmesi geri dönüş işlevi görür */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'stretch',
              backgroundColor: '#f5f5f5',
              borderBottom: '1px solid #e0e0e0'
            }}
          >
            <Tabs
              onChange={handleChangeTabs}
              value={activeTab}
              variant="fullWidth"
              sx={{
                flex: 1,
                minHeight: '46px',
                '& .MuiTab-root': {
                  minHeight: '46px',
                  padding: '6px 16px',
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'none',
                  color: '#607d8b',
                  transition: 'background-color 0.15s, color 0.15s',
                  '& .MuiSvgIcon-root': { fontSize: '18px', marginRight: '8px' }
                },
                '& .MuiTab-root:hover': { color: '#424242', backgroundColor: 'rgba(0,0,0,0.03)' },
                '& .MuiTab-root.Mui-selected': { color: '#FF9800', backgroundColor: '#fff' },
                '& .MuiTab-root.Mui-disabled': { color: '#b0bec5' }
              }}
              TabIndicatorProps={{
                style: { background: '#FF9800', height: 3, borderRadius: '3px 3px 0 0' }
              }}
            >
              <Tab
                iconPosition="start"
                icon={activeTab == 2 ? <ArrowBackIcon /> : <ListAltIcon />}
                label={activeTab == 2 ? 'Açık İşlere Dön' : 'Açık İşler'}
                value="1"
              />
              <Tab iconPosition="start" icon={<ReceiptLongSharpIcon />} label="Detay" value="2" disabled />
            </Tabs>
            {activeTab == 2 ? (
              <Box sx={{ display: 'flex', alignItems: 'center', px: 1, borderLeft: '1px solid #e0e0e0' }}>
                <Tooltip title="Detayı Yeniden Yükle">
                  <IconButton
                    size="small"
                    onClick={() => {
                      RefreshDetail();
                    }}
                    sx={{ '&:hover': { backgroundColor: 'rgba(255,152,0,0.12)' } }}
                  >
                    <RestoreIcon sx={{ fontSize: 20, color: '#FF9800' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            ) : null}
          </Box>
          <TabPanel value="1" dir={theme.direction} sx={{ padding: '12px' }}>
            <Grid>
              {userRole?.filter((i) => i.COMPONENT_ID == 1).length > 0 ? (
                <Card
                  sx={{
                    borderRadius: '16px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 6px 20px rgba(255, 152, 0, 0.15)'
                    }
                  }}
                >
                  <>
                    <Accordion
                      expanded={expanded === 'panel1'}
                      onChange={(event, isExpanded) =>
                        setExpanded(isExpanded ? 'panel1' : false)
                      }
                      sx={{
                        borderRadius: '16px',
                        '&:before': {
                          display: 'none'
                        }
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography
                          sx={{ width: '33%', flexShrink: 0 }}
                          variant="inherit"
                        >
                          Detay Ara
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                        <Grid container spacing={2.5}>
                          <Grid item xs={3}>
                            <Autocomplete
                              multiple
                              limitTags={1}
                              id="multiple-limit-tags"
                              disableCloseOnSelect
                              options={regionData}
                              getOptionLabel={(option) => option.Dsc}
                              value={selectedRegion || 0}
                              size="small"
                              fullWidth
                              onChange={(event, val) => {
                                GetCity(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Bölge"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Autocomplete
                              multiple
                              limitTags={1}
                              id="multiple-limit-tags"
                              disableCloseOnSelect
                              options={cityData}
                              getOptionLabel={(option) => option.Dsc}
                              value={selectedCity || 0}
                              size="small"
                              fullWidth
                              onChange={(event, val) => {
                                setSelectedCity(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Servis"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={3} size="small">
                            <Autocomplete
                              multiple
                              id="checkboxes-tags-demo"
                              size="small"
                              options={customerTypes}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option.Dsc}
                              onChange={(event, val) =>
                                setSelectedCustomerType(val)
                              }
                              value={selectedCustomerType}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              style={{ width: '100%' }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Müşteri Tipi"
                                  placeholder="Müşteri Tipi"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={3} size="small">
                            <Autocomplete
                              multiple
                              limitTags={1}
                              id="multiple-limit-tags"
                              disableCloseOnSelect
                              options={changeReasonData}
                              getOptionLabel={(option) => option.Dsc}
                              size="small"
                              fullWidth
                              value={selectedChangeReason || 0}
                              onChange={(event, val) => {
                                setChangeReason(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Değişim nedeni"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Autocomplete
                              limitTags={1}
                              multiple
                              disableCloseOnSelect
                              id="multiple-limit-tags"
                              options={aronStatusData}
                              getOptionLabel={(option) => option.Dsc}
                              value={selectedAronStatus || 0}
                              size="small"
                              fullWidth
                              onChange={(event, val) => {
                                setAronStatus(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Fiş Durum"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <Autocomplete
                              limitTags={1}
                              multiple
                              disableCloseOnSelect
                              id="multiple-limit-tags"
                              options={refundMoney}
                              getOptionLabel={(option) => option.Dsc}
                              value={selectedRefundMoney || 0}
                              size="small"
                              fullWidth
                              onChange={(event, val) => {
                                setRefundMoney(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Para İadesi / Değişim Çeki Durumu"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={3}>
                            <Autocomplete
                              multiple
                              limitTags={1}
                              id="multiple-limit-tags"
                              disableCloseOnSelect
                              options={statusData}
                              getOptionLabel={(option) => option.Dsc}
                              value={selectedStatus || 0}
                              size="small"
                              fullWidth
                              onChange={(event, val) => {
                                setStatus(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Durum"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Autocomplete
                              multiple
                              limitTags={1}
                              id="multiple-limit-tags"
                              disableCloseOnSelect
                              options={subStatusData}
                              getOptionLabel={(option) => option.Dsc}
                              value={selectedSubStatus || 0}
                              size="small"
                              fullWidth
                              onChange={(event, val) => {
                                setSubStatus(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Alt Durum"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Autocomplete
                              multiple
                              limitTags={1}
                              id="multiple-limit-tags"
                              disableCloseOnSelect
                              options={productsData}
                              getOptionLabel={(option) => option.Dsc}
                              value={selectedProduct || 0}
                              size="small"
                              fullWidth
                              onChange={(event, val) => {
                                setProduct(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Ürün Grubu"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Autocomplete
                              multiple
                              limitTags={1}
                              id="multiple-limit-tags"
                              disableCloseOnSelect
                              options={confirmTypeData}
                              getOptionLabel={(option) => option.Dsc}
                              value={selectedConfirmType || 0}
                              size="small"
                              fullWidth
                              onChange={(event, val) => {
                                setConfirmType(val);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.Dsc}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Onay Tipi"
                                  variant="outlined"
                                  sx={{
                                    '& .MuiOutlinedInput-root': {
                                      borderRadius: '12px',
                                      fontSize: '0.875rem',
                                      transition: 'all 0.3s ease',
                                      '&:hover': {
                                        boxShadow:
                                          '0 2px 8px rgba(255, 152, 0, 0.1)'
                                      },
                                      '&.Mui-focused': {
                                        boxShadow:
                                          '0 4px 12px rgba(255, 152, 0, 0.2)'
                                      }
                                    },
                                    '& .MuiInputLabel-root': {
                                      fontSize: '0.875rem'
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <LocalizationProvider
                              dateAdapter={AdapterDateFns}
                              locale={trLocale}
                            >
                              <DatePicker
                                label="Başlangıç Tarihi"
                                value={startDate}
                                format={'dd.MM.yyyy'}
                                onChange={(e) => handleChangeStartDate(e)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    fullWidth
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                          boxShadow:
                                            '0 2px 8px rgba(255, 152, 0, 0.1)'
                                        },
                                        '&.Mui-focused': {
                                          boxShadow:
                                            '0 4px 12px rgba(255, 152, 0, 0.2)'
                                        }
                                      },
                                      '& .MuiInputLabel-root': {
                                        fontSize: '0.875rem'
                                      }
                                    }}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={3}>
                            <LocalizationProvider
                              dateAdapter={AdapterDateFns}
                              locale={trLocale}
                            >
                              <DatePicker
                                label="Bitiş Tarihi"
                                value={endDate}
                                format={'dd.MM.yyyy'}
                                onChange={(e) => handleChangeEndDate(e)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    fullWidth
                                    sx={{
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                          boxShadow:
                                            '0 2px 8px rgba(255, 152, 0, 0.1)'
                                        },
                                        '&.Mui-focused': {
                                          boxShadow:
                                            '0 4px 12px rgba(255, 152, 0, 0.2)'
                                        }
                                      },
                                      '& .MuiInputLabel-root': {
                                        fontSize: '0.875rem'
                                      }
                                    }}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={10}></Grid>
                          <Grid item xs={2}>
                            <Button
                              fullWidth
                              size="small"
                              onClick={() => searchProductSummary()}
                              sx={{
                                color: '#FF9800',
                                backgroundColor: '#424242',
                                borderRadius: '10px',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                padding: '6px 16px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#FF9800',
                                  color: '#fff',
                                  transform: 'translateY(-2px)',
                                  boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)'
                                }
                              }}
                            >
                              Ara
                            </Button>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </>
                </Card>
              ) : null}
            </Grid>
            <Grid style={{ paddingTop: 5 }}>
              <Card
                sx={{
                  borderRadius: '16px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: '0 6px 20px rgba(255, 152, 0, 0.15)'
                  }
                }}
              >
                <>
                  <Accordion
                    expanded={expandedSearch === 'panel2'}
                    onChange={(event, isExpanded) =>
                      setExpandedSearch(isExpanded ? 'panel2' : false)
                    }
                    sx={{
                      borderRadius: '16px',
                      '&:before': {
                        display: 'none'
                      }
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography
                        sx={{ width: '33%', flexShrink: 0 }}
                        variant="inherit"
                      >
                        Özet Ara
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                      <Grid container spacing={1.5}>
                        <Grid item xs={3}>
                          <TextField
                            id="input-with-icon-textfield"
                            label="Müşteri Ad"
                            size="small"
                            type="text"
                            autoComplete="off"
                            fullWidth
                            value={customerName}
                            onChange={(event) => {
                              setCustomerName(event.target.value);
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <ManageSearchIcon
                                    sx={{
                                      color: '#FF9800',
                                      fontSize: '1.1rem'
                                    }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            variant="outlined"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  boxShadow: '0 2px 8px rgba(255, 152, 0, 0.1)'
                                },
                                '&.Mui-focused': {
                                  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
                                }
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '0.75rem'
                              },
                              '& .MuiOutlinedInput-input': {
                                padding: '8px 12px'
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            id="input-with-icon-textfield"
                            label="Müşteri Soyad"
                            size="small"
                            type="text"
                            autoComplete="off"
                            fullWidth
                            value={customerSurname}
                            onChange={(event) => {
                              setCustomerSurname(event.target.value);
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <ManageSearchIcon
                                    sx={{
                                      color: '#FF9800',
                                      fontSize: '1.1rem'
                                    }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            variant="outlined"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  boxShadow: '0 2px 8px rgba(255, 152, 0, 0.1)'
                                },
                                '&.Mui-focused': {
                                  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
                                }
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '0.75rem'
                              },
                              '& .MuiOutlinedInput-input': {
                                padding: '8px 12px'
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            id="input-with-icon-textfield"
                            label="Müşteri Telefon"
                            size="small"
                            type="number"
                            fullWidth
                            autoComplete="off"
                            inputProps={{
                              maxLength: 11
                            }}
                            value={phoneNumber}
                            onChange={(event) =>
                              setPhoneNumber(event.target.value)
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <ManageSearchIcon
                                    sx={{
                                      color: '#FF9800',
                                      fontSize: '1.1rem'
                                    }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            variant="outlined"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  boxShadow: '0 2px 8px rgba(255, 152, 0, 0.1)'
                                },
                                '&.Mui-focused': {
                                  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
                                }
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '0.75rem'
                              },
                              '& .MuiOutlinedInput-input': {
                                padding: '8px 12px'
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            id="input-with-icon-textfield"
                            autoComplete="off"
                            label="Fiş Numarası"
                            size="small"
                            InputLabelProps={{ className: classes.FisNoBox }}
                            fullWidth
                            inputProps={{
                              maxLength: 9
                            }}
                            value={receiptNumber}
                            onChange={(event) => {
                              setReceiptNumber(event.target.value);
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <ManageSearchIcon
                                    sx={{
                                      color: '#FF9800',
                                      fontSize: '1.1rem'
                                    }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            variant="outlined"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  boxShadow: '0 2px 8px rgba(255, 152, 0, 0.1)'
                                },
                                '&.Mui-focused': {
                                  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
                                }
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '0.75rem'
                              },
                              '& .MuiOutlinedInput-input': {
                                padding: '8px 12px'
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            id="input-with-icon-textfield"
                            label="Fatura Numarası"
                            size="small"
                            type="text"
                            fullWidth
                            autoComplete="off"
                            value={invoiceNumber}
                            onChange={(event) => {
                              setInvoiceNumber(event.target.value);
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <ManageSearchIcon
                                    sx={{
                                      color: '#FF9800',
                                      fontSize: '1.1rem'
                                    }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            variant="outlined"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  boxShadow: '0 2px 8px rgba(255, 152, 0, 0.1)'
                                },
                                '&.Mui-focused': {
                                  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
                                }
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '0.75rem'
                              },
                              '& .MuiOutlinedInput-input': {
                                padding: '8px 12px'
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            id="input-with-icon-textfield"
                            label="Bayi"
                            size="small"
                            type="text"
                            fullWidth
                            autoComplete="off"
                            value={retailer}
                            onChange={(event) => {
                              setRetailer(event.target.value);
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <ManageSearchIcon
                                    sx={{
                                      color: '#FF9800',
                                      fontSize: '1.1rem'
                                    }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            variant="outlined"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  boxShadow: '0 2px 8px rgba(255, 152, 0, 0.1)'
                                },
                                '&.Mui-focused': {
                                  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
                                }
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '0.75rem'
                              },
                              '& .MuiOutlinedInput-input': {
                                padding: '8px 12px'
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            id="input-with-icon-textfield"
                            label="Model Kodu"
                            size="small"
                            type="number"
                            fullWidth
                            value={modelCode}
                            autoComplete="off"
                            onChange={(event) => {
                              setModelCode(event.target.value);
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <ManageSearchIcon
                                    sx={{
                                      color: '#FF9800',
                                      fontSize: '1.1rem'
                                    }}
                                  />
                                </InputAdornment>
                              )
                            }}
                            variant="outlined"
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  boxShadow: '0 2px 8px rgba(255, 152, 0, 0.1)'
                                },
                                '&.Mui-focused': {
                                  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
                                }
                              },
                              '& .MuiInputLabel-root': {
                                fontSize: '0.75rem'
                              },
                              '& .MuiOutlinedInput-input': {
                                padding: '8px 12px'
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={10}></Grid>
                        <Grid item xs={2}>
                          <Button
                            fullWidth
                            size="small"
                            onClick={() => searchSummary()}
                            sx={{
                              color: '#FF9800',
                              backgroundColor: '#424242',
                              borderRadius: '10px',
                              fontSize: '0.75rem',
                              fontWeight: 600,
                              padding: '6px 16px',
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                backgroundColor: '#FF9800',
                                color: '#fff',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)'
                              }
                            }}
                          >
                            Ara
                          </Button>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </>
              </Card>
            </Grid>
            <Grid style={{ paddingTop: 16 }}>
              <Box
                sx={{
                  height: 1000,
                  width: '100%',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  '& .MuiDataGrid-root': {
                    border: 'none',
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px 8px 0 0',
                      borderBottom: '2px solid #FF9800',
                      minHeight: '56px !important',
                      '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 700,
                        fontSize: '0.875rem',
                        color: '#424242'
                      }
                    },
                    '& .MuiDataGrid-virtualScroller': {
                      '&::-webkit-scrollbar': {
                        width: '8px',
                        height: '8px'
                      },
                      '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '4px'
                      },
                      '&::-webkit-scrollbar-thumb': {
                        background:
                          'linear-gradient(180deg, #FF9800 0%, #F57C00 100%)',
                        borderRadius: '4px',
                        '&:hover': {
                          background:
                            'linear-gradient(180deg, #F57C00 0%, #E65100 100%)'
                        }
                      }
                    }
                  },
                  '& .cold': {
                    backgroundColor: '#FFFFFF',
                    color: 'black',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: '#fff8f0 !important',
                      transform: 'scale(1.001)',
                      boxShadow: '0 2px 8px rgba(255, 152, 0, 0.1)'
                    },
                    '&:nth-of-type(even)': {
                      backgroundColor: '#fafafa'
                    }
                  },
                  '& .hot': {
                    backgroundColor: '#FF9800',
                    color: '#424242',
                    fontWeight: 'bold',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: '#F57C00!important',
                      color: '#fff!important',
                      fontWeight: 'bold!important',
                      transform: 'scale(1.002)'
                    }
                  },
                  '& .automationRow': {
                    backgroundColor: '#ffebee',
                    color: '#c62828'
                  },
                  '& .waitingRow': {
                    backgroundColor: '#fff3e0',
                    color: '#e65100'
                  },
                  '& .nitelikRow': {
                    backgroundColor: '#FF9800',
                    color: '#fff',
                    fontWeight: '600',
                    '&:hover': {
                      backgroundColor: '#FF9800 !important',
                      color: '#fff !important',
                      fontWeight: '600'
                    }
                  },
                  '& .cold': {
                    backgroundColor: '#fff'
                  }
                }}
              >
                <DataGrid
                  sx={{ paddingBottom: '3rem' }}
                  columns={columns}
                  rows={UpdatedProductInformation}
                  rowsPerPageOptions={[25, 50, 100, 250, 500, 1000]}
                  getRowId={(row) => row.SIRA}
                  onRowClick={(row) => {
                    if (row.row.OTOMASYON_FISI_MI === 1) {
                      setSelectedAutomationRow(row.row);
                      setAutomationConfirmOpen(true);
                    } else {
                      CMDetail(row.row);
                      InsertFisListControl(row.row);
                      setFisExpanded(false);
                    }
                  }}
                  getRowClassName={(params) => {
                    if (params.row.OTOMASYON_FISI_MI === 1) {
                      return 'automationRow';
                    }
                    if (params.row.BEKLEMEDE === true) {
                      return 'waitingRow';
                    }
                    if (params.row.NITELIK_KODU == 1) {
                      return 'nitelikRow';
                    }
                    return 'cold';
                  }}
                  components={{
                    Toolbar: QuickSearchToolbar,
                    NoRowsOverlay: CustomNoRowsOverlay
                  }}
                  localeText={
                    trTR.components.MuiDataGrid.defaultProps.localeText
                  }
                  onSortModelChange={(model) => {
                    DataGridSorting(model);
                  }}
                  initialState={{
                    sorting: {
                      sortModel: dataSort
                        ? [{ field: dataSort?.field, sort: dataSort?.sort }]
                        : [{ field: 'SIRA', sort: 'asc' }]
                    }
                  }}
                />
              </Box>
            </Grid>
          </TabPanel>
          <TabPanel value="2" dir={theme.direction} sx={{ padding: '6px' }}>
            <InvoiceDetail />
          </TabPanel>
        </TabContext>
        <Accordion
          expanded={fisExpanded}
          onChange={() => {
            setFisExpanded(!fisExpanded);
          }}
          className={classes.AccordionStyle}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            sx={{ color: 'white', background: 'transparent' }}
            onClick={
              !fisExpanded
                ? () => {
                    GetFisListControl();
                  }
                : () => {}
            }
          >
            <Badge
              badgeContent={fisListControl?.length || 0}
              color="error"
              max={99}
            >
              <ReceiptLongSharpIcon style={{ color: 'white' }} />
            </Badge>
            <Typography
              className={classes.div}
              variant="subtitle1"
              sx={{
                ml: 2,
                fontWeight: 700,
                fontSize: '0.95rem',
                letterSpacing: '0.5px',
                textShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}
            >
              Fiş Listem
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              overflowY: 'auto',
              maxHeight: 320,
              background:
                'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.98) 100%)',
              padding: '8px',
              '&::-webkit-scrollbar': {
                width: '6px'
              },
              '&::-webkit-scrollbar-track': {
                background: 'rgba(0,0,0,0.05)',
                borderRadius: '8px'
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'linear-gradient(180deg, #fb923c 0%, #f97316 100%)',
                borderRadius: '8px',
                '&:hover': {
                  background:
                    'linear-gradient(180deg, #f97316 0%, #fb923c 100%)'
                }
              }
            }}
          >
            {fisListLoading ? (
              <Box
                sx={{
                  textAlign: 'center',
                  padding: '24px 12px'
                }}
              >
                <CircularProgress
                  size={32}
                  sx={{
                    color: '#f97316',
                    mb: 1.5
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{ fontSize: '0.8rem', color: '#666' }}
                >
                  Fiş listesi yükleniyor...
                </Typography>
                <Box sx={{ mt: 2 }}>
                  {[1, 2, 3].map((item) => (
                    <Skeleton
                      key={item}
                      variant="rectangular"
                      height={50}
                      sx={{
                        borderRadius: '10px',
                        mb: 1,
                        bgcolor: 'rgba(251, 146, 60, 0.1)'
                      }}
                    />
                  ))}
                </Box>
              </Box>
            ) : fisListControl?.length === 0 ? (
              <Box
                sx={{
                  textAlign: 'center',
                  padding: '24px 12px',
                  color: '#666'
                }}
              >
                <ReceiptLongSharpIcon
                  sx={{ fontSize: 36, color: '#ddd', mb: 1.5 }}
                />
                <Typography
                  variant="body2"
                  sx={{ fontSize: '0.8rem' }}
                  color="textSecondary"
                >
                  Henüz fiş eklenmemiş
                </Typography>
              </Box>
            ) : (
              fisListControl?.map((row, index) => (
                <Box
                  key={row.FIS_NO || index}
                  sx={{
                    marginBottom: '6px',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    background: 'white',
                    boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
                    border: '1px solid rgba(251, 146, 60, 0.15)',
                    '&:hover': {
                      transform: 'translateX(6px) scale(1.01)',
                      boxShadow: '0 6px 20px rgba(251, 146, 60, 0.25)',
                      border: '1px solid rgba(251, 146, 60, 0.35)'
                    },
                    '&:last-child': {
                      marginBottom: 0
                    }
                  }}
                >
                  <ListItemButton
                    onClick={() => {
                      CMDetail(row);
                      InsertFisListControl(row);
                      setFisExpanded(false);
                    }}
                    sx={{
                      padding: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      '&:hover': {
                        background:
                          'linear-gradient(90deg, rgba(251, 146, 60, 0.05) 0%, rgba(249, 115, 22, 0.05) 100%)'
                      }
                    }}
                  >
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: '8px',
                        background:
                          'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 3px 10px rgba(251, 146, 60, 0.3)',
                        transition: 'transform 0.3s ease',
                        '&:hover': {
                          transform: 'rotate(10deg) scale(1.1)'
                        }
                      }}
                    >
                      <ReceiptLongSharpIcon
                        sx={{ color: 'white', fontSize: 16 }}
                      />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          color: '#2d3748',
                          fontSize: '0.8rem',
                          letterSpacing: '0.3px'
                        }}
                      >
                        {row.FIS_NO}
                        <CopyButton value={row.FIS_NO} title="Fiş numarasını kopyala" sx={{ ml: 0.5 }} />
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#718096',
                          fontSize: '0.65rem'
                        }}
                      >
                        Fiş Numarası
                      </Typography>
                    </Box>
                    <Chip
                      label="Görüntüle"
                      size="small"
                      sx={{
                        background:
                          'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
                        color: 'white',
                        fontWeight: 600,
                        fontSize: '0.65rem',
                        height: '20px',
                        '& .MuiChip-label': {
                          padding: '0 8px'
                        }
                      }}
                    />
                  </ListItemButton>
                </Box>
              ))
            )}
          </AccordionDetails>
        </Accordion>
      </Card>
      <>
        <Print open={printOpen} setOpen={setPrintOpen} data={printData} />
      </>

      {/* Otomasyon Fiş Onay Dialog */}
      <Dialog
        open={automationConfirmOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #FFA726 100%)',
            p: 3,
            textAlign: 'center'
          }}
        >
          <CloudSyncIcon
            sx={{
              fontSize: 48,
              color: '#fff',
              mb: 2,
              animation: 'spin 2s linear infinite',
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' }
              }
            }}
          />
          <Typography
            id="alert-dialog-title"
            variant="h5"
            sx={{
              fontWeight: 700,
              color: '#fff',
              mb: 1
            }}
          >
            Fiş Otomasyonda
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.9)'
            }}
          >
            Bu fiş otomatik olarak işlenmektedir
          </Typography>
        </Box>

        <DialogContent
          sx={{
            pt: 3,
            pb: 2,
            textAlign: 'center'
          }}
        >
          <Typography
            id="alert-dialog-description"
            variant="body1"
            sx={{
              color: '#424242',
              fontWeight: '500',
              mb: 1
            }}
          >
            Detay sayfasında devam etmek istiyormusunuz?
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: '#999',
              display: 'block',
              mt: 1
            }}
          >
            Otomasyonlu fiş işlemi devam edecektir
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            p: 2,
            gap: 1,
            justifyContent: 'center',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => {
              setAutomationConfirmOpen(false);
              setSelectedAutomationRow(null);
            }}
            variant="outlined"
            sx={{
              minWidth: 120,
              borderColor: '#FF9800',
              color: '#FF9800',
              fontWeight: '600',
              textTransform: 'none',
              fontSize: '14px',
              '&:hover': {
                backgroundColor: 'rgba(255, 152, 0, 0.04)',
                borderColor: '#F57C00'
              }
            }}
          >
            Hayır, Listede Kal
          </Button>
          <Button
            onClick={() => {
              if (selectedAutomationRow) {
                CMDetail(selectedAutomationRow);
                InsertFisListControl(selectedAutomationRow);
                setFisExpanded(false);
              }
              setAutomationConfirmOpen(false);
              setSelectedAutomationRow(null);
            }}
            variant="contained"
            autoFocus
            sx={{
              minWidth: 120,
              background: 'linear-gradient(135deg, #FF9800 0%, #FFA726 100%)',
              color: '#fff',
              fontWeight: '600',
              textTransform: 'none',
              fontSize: '14px',
              boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #F57C00 0%, #FF9800 100%)',
                boxShadow: '0 6px 16px rgba(255, 152, 0, 0.4)'
              }
            }}
          >
            Evet, Devam Et
          </Button>
        </DialogActions>
      </Dialog>

      {/* Detayda Otomasyon Fiş Uyarı Dialog */}
      <Dialog
        open={automationDetailOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #FFA726 100%)',
            p: 3,
            textAlign: 'center'
          }}
        >
          <CloudSyncIcon
            sx={{
              fontSize: 48,
              color: '#fff',
              mb: 2,
              animation: 'spin 2s linear infinite',
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' }
              }
            }}
          />
          <Typography
            id="alert-dialog-title"
            variant="h5"
            sx={{
              fontWeight: 700,
              color: '#fff',
              mb: 1
            }}
          >
            Fiş Otomasyonda
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.9)'
            }}
          >
            Bu fiş otomatik olarak işlenmektedir
          </Typography>
        </Box>

        <DialogContent
          sx={{
            pt: 3,
            pb: 2,
            textAlign: 'center'
          }}
        >
          <Typography
            id="alert-dialog-description"
            variant="body1"
            sx={{
              color: '#424242',
              fontWeight: '500',
              mb: 2
            }}
          >
            ⚠️ Bu fiş otomasyon fişidir
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#666',
              lineHeight: 1.6
            }}
          >
            Fiş SAP otomasyonuna girmek üzere işlendiği için bazı onay butonları
            devre dışı bırakılmıştır. Lütfen dikkatli işlem yapınız.
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            p: 2,
            justifyContent: 'center',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            onClick={() => {
              setAutomationDetailOpen(false);
            }}
            variant="contained"
            autoFocus
            sx={{
              minWidth: 150,
              background: 'linear-gradient(135deg, #FF9800 0%, #FFA726 100%)',
              color: '#fff',
              fontWeight: '600',
              textTransform: 'none',
              fontSize: '14px',
              boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #F57C00 0%, #FF9800 100%)',
                boxShadow: '0 6px 16px rgba(255, 152, 0, 0.4)'
              }
            }}
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bekleme nedeni için popup */}

      <Dialog
        open={waitingReasonPopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogContent>
          <Typography
            sx={{ width: '100%', color: 'text.secondary', fontWeight: 'Bold' }}
            variant="subtitle1"
          >
            {waitingReceiptNo +
              ' ' +
              'fişi beklemeye alıyorsunuz. Beklemeye almak istediğinizden emin misiniz ? Lütfen bekleme sebebini yazınız.'}
          </Typography>
          <br></br>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TextField
                id="Dsc"
                label="Bekleme Sebebi Giriniz..."
                size="small"
                value={waitingDsc}
                fullWidth
                autoFocus
                autoComplete="off"
                variant="outlined"
                onChange={(event) => {
                  setWaitingDsc(event.target.value);
                }}
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Beklemeye Al">
            <IconButton
              color="primary"
              onClick={() => {
                waitingPool();
              }}
              aria-label="close"
              component="span"
              variant="contained"
            >
              <PhonePausedIcon sx={{ color: 'green' }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Kapat">
            <IconButton
              color="primary"
              onClick={() => {
                setWaitingReasonsPopUp(false);
                setWaitingDsc('');
              }}
              aria-label="close"
              component="span"
              variant="contained"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </DialogActions>
      </Dialog>
      {/* Bekleme nedeni Güncelleme İçin PopUp */}
      <Dialog
        open={waitingReasonUpdatePopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogContent>
          <Typography
            sx={{ width: '100%', color: 'text.secondary', fontWeight: 'Bold' }}
            variant="subtitle1"
          >
            {'Lütfen Yeni Bekleme Sebebini Giriniz...'}
          </Typography>
          <br></br>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TextField
                id="Dsc"
                label="Yeni Bekleme Sebebi Giriniz..."
                size="small"
                value={waitingDsc}
                fullWidth
                autoFocus
                autoComplete="off"
                variant="outlined"
                onChange={(event) => {
                  setWaitingDsc(event.target.value);
                }}
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Güncelle">
            <IconButton
              color="primary"
              onClick={() => {
                updateWaitingPoolReceipt();
              }}
              aria-label="close"
              component="span"
              variant="contained"
            >
              <CloudSyncIcon sx={{ color: 'green' }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Kapat">
            <IconButton
              color="primary"
              onClick={() => {
                setWaitingReasonUpdatePopUp(false);
                setWaitingDsc('');
              }}
              aria-label="close"
              component="span"
              variant="contained"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default GeneralFollow;
